/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { UserPage } from '../../components/UserPage';

function HealthCareProvidersPage() {
  return <UserPage userRole="hcp" />;
}

export default HealthCareProvidersPage;
